import React from 'react';
import PropTypes from 'prop-types';

import ArsenalCard from '../ArsenalCard';

function ArsenalSimpleMenu({ dataMenu }) {
    return (
        <>
            {dataMenu.results.length > 0 ? (
                <>
                    {dataMenu.results.map((meal) => (
                        <ArsenalCard meal={meal} key={meal.id} />
                    ))}
                </>
            ) : (
                <p>Aucun plat disponible pour le moment.</p>
            )}
        </>
    );
}

ArsenalSimpleMenu.propTypes = {
    dataMenu: PropTypes.object.isRequired,
};

export default ArsenalSimpleMenu;
